import {IUploadStoreState} from './IUploadStoreState';

const pageDefaultState = {
  loading: false,
  submitStatus: 'idle' as const,
};

export const uploadInitialState: IUploadStoreState = {
  file: {
    page: {...pageDefaultState},
  },
  scormPackage: {
    page: {...pageDefaultState},
  },
  webLink: {
    page: {...pageDefaultState},
  },
};
